import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { OwnerType } from '../../../constants/ComponentTypes';
import Tabs, { Tab } from 'material-ui/Tabs';
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    width: '100%',
    height: "60px",
    color: "#FFFFFF",
    background: "#040E35",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
  },

  container: {
    width: '100%',
    margin: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    backgroundColor: '#040E35',
    height: '68px',
    boxSizing: 'border-box',
    padding: '0px 0px 0px 20px',
    position: 'relative',
  },

  tabRoot: {
    width: '100px',
    fontSize: 15,
    textTransform: 'initial',
    transition: "120ms all linear",
    '&:hover, &[aria-selected=true]': {
      borderBottom: '2px solid #FFFFFF',
      color: '#FFFFFF',
      fontWeight: 'bold',
    },
    minWidth: '70px',
    border: 'none',
  },

  textColorPrimary: {
    color: '#71737B',
  },

  labelContainer: {
    padding: '10px 22px',
  },

  indicator: {
    background: 'none',
  },
});

class TabsControlSection extends React.Component {
  handleTabChange = (e, value) => {
    this.props.handleOwnerTypeChange(value);
  }

  render() {
    const { classes, user, ownerType } = this.props;

    const isShowTeam = !!user && (!!user.ownership_authority_flag || !!user.parent_id);

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Tabs
            value={ownerType}
            onChange={this.handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.indicator,
            }}
          >
            {Object.values(OwnerType).map((item, i) =>
            ((isShowTeam || (item.value === OwnerType.OWN.value)) && <Tab
              classes={{
                root: classes.tabRoot,
                textColorPrimary: classes.textColorPrimary,
                labelContainer: classes.labelContainer,
              }}
              label={<div>{item.name}</div>}
              key={i}
              value={item.value}
            >
            </Tab>))}
          </Tabs>
        </div>
      </div>
    );
  }
}

TabsControlSection.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  ownerType: PropTypes.string.isRequired,
  handleOwnerTypeChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(TabsControlSection));



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/sections/TabsControlSection.jsx